import { switchMap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomEncoder } from '../common/customer-encoder';
import { CustomerVoiceRouterService } from './cv-router.service';

@Injectable()
export class AjaxService {
  constructor(private readonly customerVoiceRouter: CustomerVoiceRouterService, private readonly http: HttpClient) {}

  get(
    route: string,
    options?: {
      headers?:
        | HttpHeaders
        | {
            [header: string]: string | string[];
          };
      params?:
        | HttpParams
        | {
            [param: string]: string | string[];
          };
      reportProgress?: boolean;
      responseType?: 'json';
      withCredentials?: boolean;
    },
  ): Observable<HttpResponse<AjaxData>> {
    return this.customerVoiceRouter.getRouteUrl(route).pipe(
      switchMap((url) => {
        return this.http.get<AjaxData>(url, {
          ...options,
          observe: 'response',
        });
      }),
    );
  }

  post(
    route: string,
    body: any | null,
    options?: {
      headers?:
        | HttpHeaders
        | {
            [header: string]: string | string[];
          };
      params?:
        | HttpParams
        | {
            [param: string]: string | string[];
          };
      reportProgress?: boolean;
      responseType?: 'json';
      withCredentials?: boolean;
    },
  ): Observable<HttpResponse<AjaxData>> {
    return this.customerVoiceRouter.getRouteUrl(route).pipe(
      switchMap((url) => {
        return this.http.post<AjaxData>(url, body, {
          ...options,
          observe: 'response',
        });
      }),
    );
  }
}

export interface AjaxData {
  data?: any;
  requestId?: string;
  responseTime?: number;
  version?: string;
}

export const formUrlEncodedHttpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
  }),
};
export const blankHttpParamsWithCustomEncoder: HttpParams = new HttpParams({
  encoder: new CustomEncoder(),
});

export function addToPayloadIfNotNull(key: string, value: string, addPayload: HttpParams): HttpParams {
  if (value) {
    addPayload = addPayload.set(key, value);
  }
  return addPayload;
}
